import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Typography,
} from "@mui/material";

const EntitySelectModal = ({
  open,
  onClose,
  onSubmit,
  entities = [],
  getLabel,
  label = "Select",
  loading = false,
}) => {
  const [selectedId, setSelectedId] = useState("");

  useEffect(() => {
    if (!open) {
      setSelectedId("");
    }
  }, [open]);

  const handleSubmit = () => {
    if (!selectedId || loading) {
      return;
    }

    onSubmit(selectedId);
  };

  const hasAvailableEntities = entities.length > 0;

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>{label}</DialogTitle>

      <DialogContent>
        {!hasAvailableEntities ? (
          <Typography sx={{ mt: 2 }} color="text.secondary">
            All available SOPs have already been added to a playbook.
          </Typography>
        ) : (
          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel id="entity-select-label">{label}</InputLabel>

            <Select
              labelId="entity-select-label"
              value={selectedId}
              label={label}
              onChange={(event) => setSelectedId(event.target.value)}
              disabled={loading}
            >
              {entities.map((entity) => (
                <MenuItem key={entity.id} value={entity.id}>
                  {getLabel(entity)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>

        <Button
          onClick={handleSubmit}
          variant="contained"
          color="secondary"
          disabled={!selectedId || loading || !hasAvailableEntities}
        >
          {loading ? "Adding..." : "Add"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EntitySelectModal;